import { render } from "./emptyCharacter.vue?vue&type=template&id=82f1f066&scoped=true"
import script from "./emptyCharacter.vue?vue&type=script&lang=js"
export * from "./emptyCharacter.vue?vue&type=script&lang=js"

import "./emptyCharacter.vue?vue&type=style&index=0&id=82f1f066&scoped=true&lang=css"

import exportComponent from "/Users/macpc-2/Downloads/Sitepal-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f1f066"]])

export default __exports__